import React from 'react';
import styled from 'styled-components';

const Table = styled.table`
  width: 100%;
`;

const HorizontalTable = styled(Table)`
  display: none;

  @media (min-width: 768px) {
    display: inline-table;
  }
`;

const VerticalTable = styled(Table)`
  display: inline-table;

  @media (min-width: 768px) {
    display: none;
  }

  margin-bottom: 20px;

  th, td {
    text-align: center;
    padding-bottom: 0;
    padding-top: 5px;
  }
`;

const Th = styled.th`
  font-size: 10px;
  font-weight: 700;
  color: #9b9b9b;
  padding: 15px 0 0;
`;

const Td = styled.td`
  font-size: 13px;
  font-weight: 700;
  padding: 0 0 15px;
`;

const Span = styled.span`
  color: #00ad83;
`;

const RARITY_COLORS = {
  legendary: '#ab964e',
  rare: '#979fa9',
  common: '#c47b43',
};

const RaritySpan = styled.span`
  color: ${props => RARITY_COLORS[props.rarity && props.rarity.toLowerCase()]};
`;

const AuctionBidTable = ({
  isAuctionEnded,
  remainingTime,
  currentBid,
  rarity,
}) => (
  <div>
    <HorizontalTable>
      <thead>
        <tr>
          <Th>Current Bid</Th>
          <Th>Time Left</Th>
          <Th>Rarity</Th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <Td><Span>Ξ</Span> {currentBid} ETH</Td>
          <Td><Span>{remainingTime}</Span></Td>
          <Td><RaritySpan rarity={rarity}>{rarity}</RaritySpan></Td>
        </tr>
      </tbody>
    </HorizontalTable>

    <VerticalTable>
      <tbody>
        <tr>
          <Th>Current Bid</Th>
        </tr>
        <tr>
          <Td><Span>Ξ</Span> {currentBid} ETH</Td>
        </tr>
        <tr>
          <Th>Time Left</Th>
        </tr>
        <tr>
          <Td><Span>{remainingTime}</Span></Td>
        </tr>
        <tr>
          <Th>Rarity</Th>
        </tr>
        <tr>
          <Td><RaritySpan rarity={rarity}>{rarity}</RaritySpan></Td>
        </tr>
      </tbody>
    </VerticalTable>
  </div>
);

export default AuctionBidTable;



// WEBPACK FOOTER //
// ./src/components/ui/AuctionBidTable.js